import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunner,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {Payday} from "../Payday";
import {NormalWin} from "../runnerpresentations/maingame/win/NormalWin";
import {LocalPresentation} from "../runnerpresentations/LocalPresentation";
import {FreeSpinsOutro} from "../runnerpresentations/freespin/FreesSpinOutro";
import {BrokeBankPresentation} from "../runnerpresentations/maingame/win/BrokeBankPresentation";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {FreeSpinsIntro} from "../runnerpresentations/freespin/FreesSpinIntro";
import {ClawsGrab} from "../runnerpresentations/ClawsGrab";
import {FreespinsRetrigger} from "../runnerpresentations/freespin/FreespinsRetrigger";

export class PaydayWinPresentation implements FlowStatePresentation {
    private presentations:SimplePresentation[];

    constructor() {
        this.presentations = [
            //new RevealWilds(),
            new ClawsGrab(),
            new NormalWin(),
            //new WinCountUp(),
            new LocalPresentation((controller:SimplePresentationRunnerController) => this.updateWin(controller),
                () => {
                    //return BrickSnake2000.model.isNonFreespinsOutroMaxWin;
                    return !Payday.model.gameData.brokeTheBank;
                },
                "UpdateWin"),
            //new SanityCheckPresentation()
            new LocalPresentation((controller:SimplePresentationRunnerController) => this.noWinPadding(controller),
                () => {return Payday.model.data.mode != GameMode.NORMAL &&
                              Payday.model.data.nextMode == GameMode.NORMAL},
                "NoWinPadding"),
            new FreeSpinsIntro(),
            new FreespinsRetrigger(),
            new BrokeBankPresentation(),
            //new ResetClaws(),
            new FreeSpinsOutro(),
        ];
    }

    private noWinPadding(controller:SimplePresentationRunnerController) {
        const isQuickstop = Payday.apiPlugin.settings.get(APISetting.FAST_SPIN);
        gsap.timeline().add(() => {}).add(() => controller.finish(), isQuickstop ? '>0.25' : '>0.5');
    }

    public start(flowStateController:FlowStateController) {
        SimplePresentationRunner.run(this.presentations, () => flowStateController.finish(), (callback?:Function) => flowStateController.setSkipCallback(callback), "WinRunner ");
    }

    private updateWin(controller:SimplePresentationRunnerController) {
        const winAmount = Payday.model.data.accumulatedRoundWin;
        Payday.keypadPlugin.setWin(winAmount,
                                       Payday.model.data.mode != GameMode.NORMAL ||
                                       Payday.model.data.nextMode != GameMode.NORMAL,
                                       Payday.isWinBelowStake());
        controller.finish();
    }
}